export default __webpack_public_path__ + "static/media/ArrowBackFilled.34ecd712.svg";